import { GET, POST } from './api'

const buildQuery = ({ portal, locale } = {}) => {
  const params = new URLSearchParams()
  if (portal) params.set('portal', portal)
  if (locale) params.set('locale', locale)
  const query = params.toString()
  return query ? `?${query}` : ''
}

const buildNavigationQuery = ({ portal, locale, stepId, itemId } = {}) => {
  const params = new URLSearchParams()
  if (portal) params.set('portal', portal)
  if (locale) params.set('locale', locale)
  if (stepId) params.set('stepId', stepId)
  if (itemId) params.set('itemId', itemId)
  const query = params.toString()
  return query ? `?${query}` : ''
}

export const ReadLearningPaths = async ({ portal, locale } = {}) => (
  GET(`/knowledge-trails${buildQuery({ portal, locale })}`, true)
)

export const ReadLearningPathDetails = async (id, { portal, locale } = {}) => {
  if (!id) return false
  return GET(`/knowledge-trails/${id}/details${buildQuery({ portal, locale })}`, true)
}

export const StartLearningPath = async (id, { portal, locale } = {}) => {
  if (!id) return false
  return POST(`/knowledge-trails/${id}/start${buildQuery({ portal, locale })}`, {}, true)
}

export const SyncLearningPath = async (id, { portal, locale } = {}) => {
  if (!id) return false
  return POST(`/knowledge-trails/${id}/sync${buildQuery({ portal, locale })}`, {}, true)
}

export const ReadLearningPathNavigation = async (id, { portal, locale, stepId, itemId } = {}) => {
  if (!id) return false
  return GET(`/knowledge-trails/${id}/navigation${buildNavigationQuery({ portal, locale, stepId, itemId })}`, true)
}

export const StartLearningPathItem = async (id, itemId, { portal, locale } = {}) => {
  if (!id || !itemId) return false
  return POST(`/knowledge-trails/${id}/items/${itemId}/start${buildQuery({ portal, locale })}`, {}, true)
}

export const CompleteLearningPathItem = async (id, itemId, { portal, locale } = {}) => {
  if (!id || !itemId) return false
  return POST(`/knowledge-trails/${id}/items/${itemId}/complete${buildQuery({ portal, locale })}`, {}, true)
}
